import axios from 'axios';
import { clearAdminAuth, getAdminToken } from '../utils/authStorage';

const adminApi = axios.create({
  baseURL: '/api',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});

adminApi.interceptors.request.use(config => {
  const token = getAdminToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      clearAdminAuth();
      window.location.href = '/admin/login';
    }
    return Promise.reject(err);
  }
);

export default adminApi;
